(function ($) {
  $(document).ready(function () {
    var search = $("header .search");
    var SearchInput = $("header input");
    var lastScrollTop = 0, $stickyNav = $('.sticky-nav');
    if ($stickyNav.length) {
      var stickyNavOffset = $stickyNav.offset().top;
    }
    $("header").addClass("fixed");
    $(window).scroll(function () {
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        // var scrollPos = $(this).scrollTop() + 91;
        // if ($stickyNav.length) {
        //   if (scrollPos >= stickyNavOffset) {
        //     $("header").removeClass("fixed");
        //   } else {
        //     $("header").addClass("fixed");
        //   }
        // } else {
          if ($(window).scrollTop() > 90) {
            $("header").removeClass("fixed");
          }
        // }
      } else {
        $("header").addClass("fixed");
      }
      lastScrollTop = st;
    });

    var hamburger = $("header .hamburger");
    $(hamburger).on("click", function () {
      var windowWidth = $(window).width();
      if (windowWidth <= 991) {
        $("body").toggleClass("nav-active");
      }
    });

    $(window).on("resize orientation", function () {
      $("body").removeClass("nav-active");
    });

    $(document).on("click", ".header .items > li", function () {
      var windowWidth = $(window).width();
      if (windowWidth <= 991) {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
        } else {
          $(".header .items > li.active").removeClass("active");
          $(this).addClass("active");
        }
      }
    });

    $('.header .wrapper .menu').each(function() {
      if ($(this).find('.dropdown').length === 0) {
        $(this).addClass('no-dropdown');
      }
     });
  
     $(search).on("click", function (e) {
      e.stopPropagation();
      $("body").removeClass("nav-active");
      $("body").toggleClass("search-active");
      $(".search-form").removeClass("focus");
      $(SearchInput).focus();
      $(SearchInput).val("");
      $("header .search-form").addClass("focus");
     });
  
    $(SearchInput).on("focus", function () {
      $("header .search-form").addClass("focus");
    });
    $(SearchInput).on("blur", function () {
      $("header .search-form").removeClass("focus");
    });
  
    $(SearchInput).keyup(function () {
      var searchVal = $(this).val();
      if (searchVal == "") {
        $(this).closest(".search-form").removeClass("has-value");
      } else {
        $(this).closest(".search-form").addClass("has-value");
      }
    });
  
    $("header .search-box .close-icon").on("click", function (event) {
      event.stopPropagation();
      $("body").removeClass("search-active");
    });
  
    $(".search-reset").click(function () {
      $(".search-box input").val("");
      $(".search-form").removeClass("has-value");
    });
  
    $(document).on("click", "header .search-box", function (event) {
      event.stopPropagation();
    });
  
    $("header .search-box .close-icon").on("click", function (event) {
      event.stopPropagation();
      $("body").removeClass("search-active");
    });
  });
})(jQuery);
  